var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAllowedToUpload)?_c('no-mortgage-data-upload-page'):_c('no-mortgage-alternatives-page')
}
var staticRenderFns = []

export { render, staticRenderFns }